var path = 'scripts/views/components/feedback-component.html';
var html = "<div ng-if=\"feedbackComponentController.displayFeedbackButton()\">\n    <button id=\"feedback\" class=\"feedback-position\"\n            ng-click=\"feedbackComponentController.openFeedbackWindow()\">\n        <span>Give Feedback</span>\n    </button>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/views/components/feedback-component.html
// module id = 316
// module chunks = 0